<template>
  <div class="overall-bg">
    <b-container fluid="xl">
      <b-row v-if="tstatus == false">
        <b-col>
          <BacktoPage path="/Masters"></BacktoPage>
          <Headerlayout :headertext="$t('ItemCategory.ItemCategorySupplierMapping.List')" :contenttext="$t('ItemCategory.ItemCategorySupplierMapping.TableHeaderContent')
            ">
          </Headerlayout>
        </b-col>
      </b-row>

      <b-row class="py-3">
        <b-col>
          <div v-if="windowWidth > 545">
            <SkeletonTableLoader :columns="headers" :loading="loading" />
            <div v-if="!loading">
              <MasterEmpty v-if="List.length === 0 && !loading" eheader="Item Supplier" econtent="Item Supplier"
                eimg="/src/assets/Img/icons/groupmaster.svg" @createNew="IsAdd" />
              <div class="">
                <Tableview v-if="List.length !== 0" :value="List" :paginator="true" class="p-datatable-gridlines"
                  :rows="10" :rowHover="true" filterDisplay="menu" :loading="loading1" responsiveLayout="scroll"
                  :columns="headers" :globalFilterFields="globalFilterFields" :filters="filters" selectionMode="single"
                  @row-click="RowClick" :exceldownload="true">
                  <template v-slot:Add>
                    <span class="add">
                      <AddButton @click="IsAdd" :btnname="$t('btn.plusaddnew')" class="float-rights my-3"></AddButton>
                    </span>
                  </template>
                  <template v-slot:exceldownload>
                    <ExportOption @ExportExcel="ExportExcel" @ExportPDF="ExportPDF" :ExportList="ExportList"
                      PageName="Item Supplier Mapping" :ExportOption="ExportOption" class="ms-2" :HideAndShow="true" />
                  </template>
                  <template v-slot:action="{ data }">
                    <span>
                      <Button icon="pi pi-ellipsis-v" class="p-button-rounded editicon p-button-text"
                        @click="toggle($event, data)" />
                    </span>
                  </template>
                  <template v-slot:CategoryCount="{ data }">
                    <p @click="navigatetopage(data.ItemCount, data)">
                      {{ data.CategoryCount }}
                    </p>
                  </template>
                </Tableview>
              </div>
            </div>
          </div>
          <div v-if="windowWidth <= 545">
            <MobileLoader v-if="loading" v-for="item in 5" />
            <div v-if="!loading">
              <MasterEmpty v-if="List.length === 0 && !loading" eheader="Item Supplier" econtent="Item Supplier"
                eimg="/src/assets/Img/icons/groupmaster.svg" @createNew="IsAdd" />
              <MobileViewCardHeader>
                <template v-slot:mobilecard>
                  <div class="mobile-card" v-for="item in List">
                    <div class="d-flex align-items-center justify-content-between gap-2">
                      <div>
                        <p class="name">{{ item.SupplierName }}</p>
                      </div>
                      <i class="pi pi-ellipsis-v" @click="toggle($event, item)"></i>
                    </div>
                    <div class="d-flex align-items-center gap-2">
                      <p class="light-name">Category Count :</p>
                      <p class="small-name">{{ item.CategoryCount }}</p>
                    </div>
                  </div>
                </template>
              </MobileViewCardHeader>
            </div>
          </div>
          <ItemSupplierMappingCreation v-model:trigger="showDialog" v-if="showDialog" v-model:selected-item="editItems"
            @load="IsShow(), (showDialog = false)" @close="showDialog = false" @loaderhide="loading = false"
            @loadershow="loading = true" :OperationID="ObjOperationId" />
        </b-col>
      </b-row>
    </b-container>
  </div>

  <Menu ref="menu" id="overlay_menu" :model="itemListed" @click="" :popup="true" />
  <EditConfirmation :Editmodel="Editmodel" @yes="IsEdit(dataEdit)" @no="Editmodel = false"
    :content="$t('confirmation.editcontent')" />
  <DeleteConfirmationVue :DeleteModel="Deletemodel" :content="content" @yes="IsDelete(dataEdit)"
    @no="Deletemodel = false" />
  <DeletedSuccessfully :visible="deletepop" @ok="closetrigger()" />
  <Mapping :content="ContentName" :visible="MappingPopup" @ok="closemapping()" />
  <Toast />
</template>

<script lang="ts">
import {
  defineComponent,
  ref,
  h,
  computed,
  onMounted,
  watch,
  onUnmounted,
} from "vue";
import { RouterLink, RouterView, useRoute, useRouter } from "vue-router";

import Headerlayout from "../../../../../../components/Masters/HeaderLayout.vue";
import BacktoPage from "../../../../../../components/FormComponents/BacktoMaster.vue";

import Unitcreastion from "../../../Masters/Items/UnitMaster/UnitCreation.vue";
import axios from "axios";
import service from "../../../../Service/SupplierCategoryMappingService";

import { FilterMatchMode, FilterOperator } from "primevue/api";

import Tableview from "../../../../../../components/FormComponents/Table.vue";
import { useI18n } from "vue-i18n";

import EditConfirmation from "../../../../../../components/FormComponents/EditConfirmation.vue";
import DeleteConfirmationVue from "../../../../../../components/FormComponents/DeleteConfirmation.vue";
import DeletedSuccessfully from "../../../../../../components/FormComponents/DeletedSuccessfully.vue";
import Mapping from "../../../../../../components/FormComponents/Mapping.vue";
import ItemSupplierMappingCreation from "../ItemSupplierMapping/ItemSupplierMappingCreation.vue";
import MasterEmpty from "../../../../../../components/Masters/MasterEmpty.vue";
import Loader from "../../../../../../components/FormComponents/Loader.vue";

import MastersService from "../../../../Service/MastersService";
import { useToast } from "primevue/usetoast";
import { checkPermission } from "../../../../Service/AccessControl";
import SkeletonTableLoader from "../../../../../../components/FormComponents/SkeletonTableLoader.vue";
import MobileViewCardHeader from "../../../../../../components/FormComponents/MobileViewCardHeader.vue";
import MobileLoader from "../../../../../../components/SkeletonLoaderComponents/ContactCardView.vue";
import ExportOption from "../../../../../../components/FormComponents/Export.vue";

export default defineComponent({
  components: {
    Mapping,
    BacktoPage,
    Headerlayout,
    Unitcreastion,
    axios,
    service,

    Tableview,
    EditConfirmation,
    DeleteConfirmationVue,
    DeletedSuccessfully,
    ItemSupplierMappingCreation,
    MasterEmpty,
    Loader,
    SkeletonTableLoader,
    MobileViewCardHeader,
    MobileLoader,
    ExportOption,
  },
  props: {
    tstatus: {
      default: false,
      type: Boolean,
    },

    storeid: {
      default: "",
      type: String,
    },
    propsParams: {
      type: Object,
    },
  },
  // props: {
  //   propsParams: {
  //     type: Object
  //   }
  // },

  setup(props) {
    debugger;

    const toast = useToast();
    const ObjData = ref();
    let content = ref("");
    let ObjOperationId = ref({
      CreateId: 0,
      UpdateId: 0,
      ReadId: 0,
      DeleteId: 0,
    });

    const routes = useRoute();
    const items = ref([]);
    let loading = ref(false);

    const router = useRouter();
    let dataId = routes.query.Id ?? 0;
    let columnnametype = routes.query.Type ?? "";

    //get local storage session data
    let SessionUserData = localStorage.getItem("UsersData");
    let usersData;
    if (SessionUserData !== null) {
      usersData = JSON.parse(SessionUserData);
    }

    let SessionRolesData = localStorage.getItem("RolesData");
    let rolesData;
    if (SessionRolesData !== null) {
      rolesData = JSON.parse(SessionRolesData);
    }

    let SessionEntityData = localStorage.getItem("EntityData");
    let EntityData;
    if (SessionEntityData !== null) {
      EntityData = JSON.parse(SessionEntityData);
    }
    //

    const windowWidth = ref(window.innerWidth);
    const handleResize = () => {
      windowWidth.value = window.innerWidth;
    };

    onMounted(() => {
      debugger;
      document.addEventListener("keydown", onKeyUp);
      window.addEventListener("resize", handleResize);
      FunctionRights();
      IsShow();
    });

    onUnmounted(() => {
      window.removeEventListener("resize", handleResize);
    });

    let Rights = ref({
      Create: false,
      Update: false,
      Read: false,
      Delete: false,
    });

    async function FunctionRights() {
      //
      debugger;
      const response = await MastersService.CheckMenuRights(
        EntityData.EntityId,
        rolesData.RoleId
      );
      console.log(response["result"]);

      for (let i = 0; i < response["result"].length; i++) {
        const operation = response["result"][i];
        if (operation.OperationName === "Create") {
          ObjOperationId.value.CreateId = operation.OperationID;
          Rights.value.Create = operation.IsActive;
        } else if (operation.OperationName === "Update") {
          ObjOperationId.value.UpdateId = operation.OperationID;
          Rights.value.Update = operation.IsActive;
        } else if (operation.OperationName === "Read") {
          ObjOperationId.value.ReadId = operation.OperationID;
          Rights.value.Read = operation.IsActive;
        } else if (operation.OperationName === "Delete") {
          ObjOperationId.value.DeleteId = operation.OperationID;
          Rights.value.Delete = operation.IsActive;
        }
      }
    }

    watch(props, (newValue) => {
      debugger;
      let dataValue: any = {};
      Object.assign(dataValue, newValue.propsParams);
      if (dataValue.Id) {
        items.value = [];
        dataId = dataValue.Id;
        status = dataValue.Type;
        IsShow();
      }
    });
    debugger;
    let MappingPopup = ref(false);
    let ContentName = ref("");
    const filter = "";
    const showmodalref = ref(false);
    let loading1 = ref(false);
    let title = "Unit Master";
    const showDialog = ref(false);
    let List: any = ref([]);
    const selectedItem = ref();
    const data = ref([]);

    const editItems = ref();
    const Editmodel = ref(false);
    const { t } = useI18n();
    const Deletemodel = ref(false);
    const deletepop = ref(false);
    const rowFocus = ref(false);

    IsShow();

    const headers = [
      {
        header: t("ItemCategory.ItemCategorySupplierMapping.sno"),
        field: "RowNumber",
        class: "filterdisplaynone smallwidth",
      },
      {
        header: t("ItemCategory.ItemCategorySupplierMapping.Suppliername"),
        field: "SupplierName",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        bodyclass: "boldclass text_overflow1",
        class: "mediumwidth",
      },
      {
        header: t("ItemCategory.ItemCategorySupplierMapping.itemcatcount"),
        field: "CategoryCount",
        filterTemplate: "MultiSelect",
        ShowMactchMode: false,
        fieldDisplay: "false",
        bodyclass: "bluecolor",
        slot: "CategoryCount",
      },
      {
        header: "",
        field: "action",
        slot: "action",
        frozencolumn: true,
        sortable: false,
        fieldDisplay: "false",
        class: "filterdisplaynone last-column-position",
      },
    ];
    const filters = {
      global: { value: null, matchMode: FilterMatchMode.CONTAINS },
      CategoryCount: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
      SupplierName: {
        value: null,
        matchMode: FilterMatchMode.IN,
        options: List,
      },
    };
    function navigatetopage(datacount, datas) {
      if (datacount != 0) {
        editItems.value = datas;
        loading.value = false;
        showDialog.value = true;
      } else {
        // alert('s')
      }
    }
    const filteredColumns = computed(() => {
      return headers.filter((col) => col.field !== "id");
    });

    const globalFilterFields = ref(headers.map((col) => col.field));

    const menu = ref();

    const toggle = (event, data) => {
      debugger;
      ObjData.value = data;
      menu.value.toggle(event);
    };

    const itemListed = ref([
      {
        items: [
          {
            label: "Edit",
            icon: "editicon pi pi-pencil",
            visible: true,
            command: async () => {
              IsConfirmEdit(ObjData);
            },
          },
          {
            label: "Delete",
            icon: "deleteicon pi pi-trash",
            visible: true,
            command: async () => {
              IsConfirmDel(ObjData);
            },
          },
        ],
      },
    ]);

    let ExportOption = ref("");
    let ExportList = ref([]);

    function ExportExcel() {
      debugger;
      ExportOption.value = "Excel";
      IsShowExport();
    }

    function ExportPDF() {
      debugger;
      ExportOption.value = "PDF";
      IsShowExport();
    }

    async function IsShowExport() {
      debugger;
      try {
        loading.value = false;

        const response = await service.CategoryList();
        debugger;
        let count = 0;

        response["result"] = response["result"]
          .filter((items) => items.HospitalId == usersData.OrganizationId)
          .map((item) => {
            count = count + 1;
            item.RowNumber = count;

            return item;
          });

        if (columnnametype == "SupplierId") {
          List.value = response["result"].filter(
            (item) => item.SupplierId == dataId
          );
        } else {
          List.value = response["result"];
        }

        ExportList.value = response["result"].map((item) => {
          const filteredItem = {};

          headers.forEach(({ header, field }) => {
            filteredItem[header] = item[field];
          });

          return filteredItem;
        });

        console.log("ContactTable Data", List.value);

        loading.value = false;
      } catch (error) {
        loading.value = false;
      }
    }

    const dataEdit = ref();
    function onKeyUp(event: any) {
      debugger;

      console.log(dataEdit.value);
      if (
        (event.key == "e" ||
          (Editmodel.value == false && event.key == "Enter")) &&
        rowFocus.value == true &&
        showDialog.value == false
      ) {
        Editmodel.value = true;
      } else if (event.altKey && event.key == "n") {
        IsAdd();
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Deletemodel.value == true &&
        Editmodel.value == false &&
        rowFocus.value == true
      ) {
        IsDelete(dataEdit.value);
      } else if (
        (event.key == "y" || event.key == "Enter") &&
        Editmodel.value == true &&
        rowFocus.value == true
      ) {
        IsEdit(dataEdit.value);
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Editmodel.value == true
      ) {
        Editmodel.value = false;
      } else if (
        event.key == "d" &&
        rowFocus.value == true &&
        showDialog.value == false
      ) {
        Deletemodel.value = true;
        Editmodel.value = false;
      } else if (
        event.key == "n" &&
        rowFocus.value == true &&
        Deletemodel.value == true
      ) {
        Deletemodel.value = false;
      } else if (event.key == "Escape" && deletepop.value == true) {
        deletepop.value = false;
      } else if (event.key == "Enter" && rowFocus.value == false) {
        Editmodel.value = false;
      } else if (event.key == "Escape" && MappingPopup.value == true) {
        MappingPopup.value = false;
        Deletemodel.value = false;
      }
    }

    function RowClick(event: any) {
      debugger;
      rowFocus.value = true;
    }

    function IsAdd() {
      debugger;

      let permissionResult: any = checkPermission(Rights, "Add");
      if (permissionResult.hasPermission) {
        showDialog.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }
    function closemapping() {
      MappingPopup.value = false;
      Deletemodel.value = false;
    }
    function IsConfirmEdit(data) {
      debugger;

      let permissionResult: any = checkPermission(Rights, "Edit");
      if (permissionResult.hasPermission) {
        dataEdit.value = data;
        Editmodel.value = true;
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }
    function IsConfirmDel(data) {
      debugger;

      let permissionResult: any = checkPermission(Rights, "Delete");
      if (permissionResult.hasPermission) {
        dataEdit.value = data;
        Editmodel.value = false;
        Deletemodel.value = true;
        content.value = t("confirmation.deletecontent");
      } else {
        toast.add(permissionResult.toast);
        return;
      }
    }
    // Popup-Close
    function closetrigger() {
      deletepop.value = false;
    }

    //Table List
    async function IsShow() {
      loading.value = true;
      try {
        const response = await service.CategoryList();
        debugger;
        let count = 0;

        response["result"] = response["result"]
          .filter((items) => {
            const branchIds = Array.isArray(usersData.BranchId)
              ? usersData.BranchId
              : typeof usersData.BranchId === "string"
                ? usersData.BranchId.split(",").map((id) => id.trim())
                : [usersData.BranchId.toString()];
            return (
              items.HospitalId == usersData.OrganizationId &&
              items.BranchId != null &&
              branchIds.includes(items.BranchId.toString())
            );
          })
          .map((item) => {
            count = count + 1;
            item.RowNumber = count;

            return item;
          });

        if (columnnametype == "SupplierId") {
          List.value = response["result"].filter(
            (item) => item.SupplierId == dataId
          );
        } else {
          List.value = response["result"];
        }
        loading.value = false;
        console.log(List.value);
      } catch (error) {
        loading.value = false;
        alert(error);
      }
    }

    //Row Edit
    function IsEdit(data) {
      debugger;
      editItems.value = data;
      showDialog.value = true;
      Editmodel.value = false;
    }

    //Row Delete
    async function IsDelete(data) {
      debugger;
      loading.value = true;
      const DelID = data.value.SupplierId;
      try {
        const response = await service.deletedata(DelID);
        let message = response["ErrorInfo"].ErrorCode;
        loading.value = false;
        if (message == null) {
          deletepop.value = true;
          Deletemodel.value = false;
          rowFocus.value = false;
          IsShow();
        }
      } catch (error) {
        loading.value = false;
        alert(error);
      }
    }

    return {
      ObjOperationId,
      navigatetopage,
      ContentName,
      MappingPopup,
      headers,
      showmodalref,
      showpopModal: showmodalref,

      title,
      filter,
      loading1,
      List,
      filters,
      globalFilterFields,
      filteredColumns,
      showDialog: showDialog,
      selectedItem,
      data,
      closemapping,
      IsEdit,
      IsDelete,
      IsShow,
      RowClick,

      onKeyUp,
      IsAdd,
      IsConfirmEdit,
      IsConfirmDel,
      closetrigger,
      Editmodel,
      editItems,
      Deletemodel,
      deletepop,
      dataEdit,
      loading,
      menu,
      toggle,
      itemListed,
      content,
      windowWidth,
      ExportExcel,
      ExportOption,
      ExportPDF,
      ExportList,
    };
  },
});
</script>

<style lang="scss" scoped>
.mobilecategoryname {
  font-size: 16px;
  font-weight: 500;
  overflow: hidden;
  text-overflow: ellipsis;
  display: -webkit-box;
  -webkit-line-clamp: 1;
  -webkit-box-orient: vertical;
}

.mobilestorename {
  font-size: 14px;
  color: #999999;
}

.mobilestorelabel {
  font-size: 14px;
  font-weight: 600;
}
</style>
